export enum OwnerTypeEnum {
  'Eje',
  'Leje',
  'Andel',
  'Firmabil_Leje',
  'Firmabil_Eje'
}
